export default {
  route: {
  },
  login: {
    site: 'SITE',
    title: '登入標題',
    logIn: '登入',
    username: '使用者帳號',
    password: '密碼',
    license: '設備登入'
  }
}
